import React from 'react';
import type { Locales } from 'cms/cms-types';
import { type Filter, type ListingFiltersState } from '3-components/ListingApp/ListingFilters/ListingFiltersTypes';
import { type ListingPaginationState } from '3-components/ListingApp/ListingPagination/ListingPagination';
import { type ListingUILabel } from '3-components/ListingApp/ListingUI/ListingUI';
import { type PeopleListingQuery } from 'cms/cms';

export type AppStatus = 'initial-loading' | 'fetching' | 'initial-error' | 'error' | 'ready';

export interface PeopleListingLabel extends ListingUILabel {
    title?: string;
    subtitle?: string;
    clearFilterButton: string;
    filterHeading?: string;
    cardCtaLabel: string;
}

export interface PeopleListingCMSConfig {
    apiKey: string;
    apiUrl?: string;
}

export interface PeopleListingProps {
    locale?: Locales;
    cms: PeopleListingCMSConfig;
    label: PeopleListingLabel;
    listing: {
        filters?: Filter[];
        filterByAncestors?: string[];
        filterByGuid?: string[]; // if this is available, itemsPerPage will be ignored
        itemsPerPage: number;
    };
    data: PeopleListingQuery;
    serverData: string;
    serverPageUrl: string;
}

export interface PeopleListingContextProps extends PeopleListingProps, ListingFiltersState, ListingPaginationState {
    // appStatus: AppStatus;
    // setAppStatus: React.Dispatch<React.SetStateAction<AppStatus>>;
    // errorMessage: string;
    // setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
}

const PeopleListingContext = React.createContext<Partial<PeopleListingContextProps>>({});

export default PeopleListingContext;
